import React from "react";
import PropTypes from "prop-types";

const Kbbimage = ({ position }) => {
    return (
        <div>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="410"
                height="260"
                viewBox="0 0 210 260">
                <defs>
                    <linearGradient
                        id="fan-above-range-i"
                        x1="49.42%"
                        x2="49.73%"
                        y1="-26.23%"
                        y2="14.21%"
                    >
                        <stop offset="0%" stopColor="#FFEEC3" />
                        <stop offset="38%" stopColor="#F3D070" />
                        <stop offset="57%" stopColor="#E3B54E" />
                        <stop offset="62%" stopColor="#AE732A" />
                        <stop offset="65%" stopColor="#AE732A" />
                        <stop offset="72%" stopColor="#F1D76F" />
                        <stop offset="79%" stopColor="#F6E57E" />
                        <stop offset="84%" stopColor="#F8F3A6" />
                        <stop offset="89%" stopColor="#FFF1C6" />
                        <stop offset="94%" stopColor="#E4AE25" />
                        <stop offset="100%" stopColor="#FBCB4B" />
                    </linearGradient>
                    <linearGradient
                        id="fan-above-range-j"
                        x1="49.38%"
                        x2="49.81%"
                        y1="-17.22%"
                        y2="29.43%"
                    >
                        <stop offset="0%" stopColor="#FFEEC3" />
                        <stop offset="46.43%" stopColor="#E3B54E" />
                        <stop offset="57.5%" stopColor="#F6E57E" />
                        <stop offset="65%" stopColor="#AE732A" />
                        <stop offset="72%" stopColor="#F1D76F" />
                        <stop offset="100%" stopColor="#FBCB4B" />
                    </linearGradient>
                    <linearGradient
                        id="fan-above-range-k"
                        x1="17.75%"
                        x2="66.56%"
                        y1="-13.86%"
                        y2="82.83%"
                    >
                        <stop offset="0%" stopColor="#FFEEC3" />
                        <stop offset="18%" stopColor="#F6E57E" />
                        <stop offset="52.5%" stopColor="#E29A39" />
                        <stop offset="76.61%" stopColor="#F5E589" />
                        <stop offset="100%" stopColor="#F9BE4A" />
                    </linearGradient>
                    <linearGradient
                        id="fan-above-range-m"
                        x1="-43.27%"
                        x2="108.85%"
                        y1="-53.11%"
                        y2="113.58%"
                    >
                        <stop offset="0%" stopColor="#FFEEC3" />
                        <stop offset="45.17%" stopColor="#F1D76F" />
                        <stop offset="95%" stopColor="#FFF1C6" />
                    </linearGradient>
                    <linearGradient
                        id="fan-above-range-n"
                        x1="-20.5%"
                        x2="91.52%"
                        y1=".41%"
                        y2="95.44%"
                    >
                        <stop offset="0%" stopColor="#FFEEC3" />
                        <stop offset="45.17%" stopColor="#F1D76F" />
                        <stop offset="95%" stopColor="#FFF1C6" />
                    </linearGradient>
                    <linearGradient
                        id="fan-above-range-o"
                        x1="-31.89%"
                        x2="92.53%"
                        y1="-19.68%"
                        y2="101.81%"
                    >
                        <stop offset="0%" stopColor="#FFEEC3" />
                        <stop offset="45.17%" stopColor="#F1D76F" />
                        <stop offset="95%" stopColor="#FFF1C6" />
                    </linearGradient>
                    <linearGradient
                        id="fan-above-range-p"
                        x1="5.92%"
                        x2="77.25%"
                        y1="-31.37%"
                        y2="100.59%"
                    >
                        <stop offset="0%" stopColor="#FFEEC3" />
                        <stop offset="45.17%" stopColor="#F1D76F" />
                        <stop offset="95%" stopColor="#FFF1C6" />
                    </linearGradient>
                    <linearGradient
                        id="fan-above-range-q"
                        x1="-34.37%"
                        x2="101.7%"
                        y1="-72.3%"
                        y2="126.17%"
                    >
                        <stop offset="0%" stopColor="#FFEEC3" />
                        <stop offset="45.17%" stopColor="#F1D76F" />
                        <stop offset="95%" stopColor="#FFF1C6" />
                    </linearGradient>
                    <linearGradient
                        id="fan-above-range-r"
                        x1="15.68%"
                        x2="71.25%"
                        y1="-57.51%"
                        y2="116.38%"
                    >
                        <stop offset="0%" stopColor="#FFEEC3" />
                        <stop offset="45.17%" stopColor="#F1D76F" />
                        <stop offset="95%" stopColor="#FFF1C6" />
                    </linearGradient>
                    <linearGradient
                        id="fan-above-range-s"
                        x1="-49.78%"
                        x2="114.97%"
                        y1="-80.44%"
                        y2="155%"
                    >
                        <stop offset="0%" stopColor="#FFEEC3" />
                        <stop offset="45.17%" stopColor="#F1D76F" />
                        <stop offset="95%" stopColor="#FFF1C6" />
                    </linearGradient>
                    <linearGradient
                        id="fan-above-range-t"
                        x1="-53.44%"
                        x2="100.3%"
                        y1="-106.61%"
                        y2="162.59%"
                    >
                        <stop offset="0%" stopColor="#FFEEC3" />
                        <stop offset="45.17%" stopColor="#F1D76F" />
                        <stop offset="95%" stopColor="#FFF1C6" />
                    </linearGradient>
                    <linearGradient
                        id="fan-above-range-u"
                        x1="-48.95%"
                        x2="110.75%"
                        y1="-91.79%"
                        y2="137.97%"
                    >
                        <stop offset="0%" stopColor="#FFEEC3" />
                        <stop offset="45.17%" stopColor="#F1D76F" />
                        <stop offset="95%" stopColor="#FFF1C6" />
                    </linearGradient>
                    <linearGradient
                        id="fan-above-range-v"
                        x1="-45.87%"
                        x2="118.27%"
                        y1="-82.77%"
                        y2="134.95%"
                    >
                        <stop offset="0%" stopColor="#FFEEC3" />
                        <stop offset="45.17%" stopColor="#F1D76F" />
                        <stop offset="95%" stopColor="#FFF1C6" />
                    </linearGradient>
                    <linearGradient
                        id="fan-above-range-w"
                        x1="-64.57%"
                        x2="120.94%"
                        y1="-108.14%"
                        y2="147.76%"
                    >
                        <stop offset="0%" stopColor="#FFEEC3" />
                        <stop offset="45.17%" stopColor="#F1D76F" />
                        <stop offset="95%" stopColor="#FFF1C6" />
                    </linearGradient>
                    <linearGradient
                        id="fan-above-range-x"
                        x1="-58.43%"
                        x2="126.52%"
                        y1="-91.3%"
                        y2="129.35%"
                    >
                        <stop offset="0%" stopColor="#FFEEC3" />
                        <stop offset="45.17%" stopColor="#F1D76F" />
                        <stop offset="95%" stopColor="#FFF1C6" />
                    </linearGradient>
                    <linearGradient
                        id="fan-above-range-y"
                        x1="-70.55%"
                        x2="124.7%"
                        y1="-82.69%"
                        y2="132.64%"
                    >
                        <stop offset="0%" stopColor="#FFEEC3" />
                        <stop offset="45.17%" stopColor="#F1D76F" />
                        <stop offset="95%" stopColor="#FFF1C6" />
                    </linearGradient>
                    <linearGradient
                        id="fan-above-range-z"
                        x1="-49.07%"
                        x2="110.92%"
                        y1="-121.21%"
                        y2="156.75%"
                    >
                        <stop offset="0%" stopColor="#FFEEC3" />
                        <stop offset="45.17%" stopColor="#F1D76F" />
                        <stop offset="95%" stopColor="#FFF1C6" />
                    </linearGradient>
                    <linearGradient
                        id="fan-above-range-A"
                        x1="-17.27%"
                        x2="91.54%"
                        y1="-78.03%"
                        y2="129.54%"
                    >
                        <stop offset="0%" stopColor="#FFEEC3" />
                        <stop offset="45.17%" stopColor="#F1D76F" />
                        <stop offset="95%" stopColor="#FFF1C6" />
                    </linearGradient>
                    <linearGradient
                        id="fan-above-range-B"
                        x1="-17.26%"
                        x2="91.57%"
                        y1="-78.33%"
                        y2="129.23%"
                    >
                        <stop offset="0%" stopColor="#FFEEC3" />
                        <stop offset="45.17%" stopColor="#F1D76F" />
                        <stop offset="95%" stopColor="#FFF1C6" />
                    </linearGradient>
                    <linearGradient
                        id="fan-above-range-C"
                        x1="-33.24%"
                        x2="94%"
                        y1="-100.87%"
                        y2="143.11%"
                    >
                        <stop offset="0%" stopColor="#FFEEC3" />
                        <stop offset="45.17%" stopColor="#F1D76F" />
                        <stop offset="95%" stopColor="#FFF1C6" />
                    </linearGradient>
                    <linearGradient
                        id="fan-above-range-D"
                        x1="-25.57%"
                        x2="96.71%"
                        y1="-109.56%"
                        y2="148.6%"
                    >
                        <stop offset="0%" stopColor="#FFEEC3" />
                        <stop offset="45.17%" stopColor="#F1D76F" />
                        <stop offset="95%" stopColor="#FFF1C6" />
                    </linearGradient>
                    <linearGradient
                        id="fan-above-range-E"
                        x1="-26.62%"
                        x2="98.66%"
                        y1="-105.63%"
                        y2="131.97%"
                    >
                        <stop offset="0%" stopColor="#FFEEC3" />
                        <stop offset="45.17%" stopColor="#F1D76F" />
                        <stop offset="95%" stopColor="#FFF1C6" />
                    </linearGradient>
                    <linearGradient
                        id="fan-above-range-F"
                        x1="-29.97%"
                        x2="89.97%"
                        y1="-99.72%"
                        y2="157.86%"
                    >
                        <stop offset="0%" stopColor="#FFEEC3" />
                        <stop offset="45.17%" stopColor="#F1D76F" />
                        <stop offset="95%" stopColor="#FFF1C6" />
                    </linearGradient>
                    <linearGradient
                        id="fan-above-range-G"
                        x1="-33.26%"
                        x2="94.02%"
                        y1="-100.96%"
                        y2="143.07%"
                    >
                        <stop offset="0%" stopColor="#FFEEC3" />
                        <stop offset="45.17%" stopColor="#F1D76F" />
                        <stop offset="95%" stopColor="#FFF1C6" />
                    </linearGradient>
                    <linearGradient
                        id="fan-above-range-H"
                        x1="-42.41%"
                        x2="100.77%"
                        y1="-29.2%"
                        y2="118.77%"
                    >
                        <stop offset="0%" stopColor="#FFEEC3" />
                        <stop offset="45.17%" stopColor="#F1D76F" />
                        <stop offset="95%" stopColor="#FFF1C6" />
                    </linearGradient>
                    <linearGradient
                        id="fan-above-range-I"
                        x1="-32.69%"
                        x2="101.45%"
                        y1="-52.38%"
                        y2="113.21%"
                    >
                        <stop offset="0%" stopColor="#FFEEC3" />
                        <stop offset="45.17%" stopColor="#F1D76F" />
                        <stop offset="95%" stopColor="#FFF1C6" />
                    </linearGradient>
                    <linearGradient
                        id="fan-above-range-J"
                        x1="-18.95%"
                        x2="94.02%"
                        y1="-80.57%"
                        y2="142.74%"
                    >
                        <stop offset="0%" stopColor="#FFEEC3" />
                        <stop offset="45.17%" stopColor="#F1D76F" />
                        <stop offset="95%" stopColor="#FFF1C6" />
                    </linearGradient>
                    <linearGradient
                        id="fan-above-range-K"
                        x1="-66.56%"
                        x2="105.78%"
                        y1="-109.73%"
                        y2="165.31%"
                    >
                        <stop offset="0%" stopColor="#FFEEC3" />
                        <stop offset="45.17%" stopColor="#F1D76F" />
                        <stop offset="95%" stopColor="#FFF1C6" />
                    </linearGradient>
                    <linearGradient
                        id="fan-above-range-L"
                        x1="-52.57%"
                        x2="114.02%"
                        y1="-89.3%"
                        y2="136.69%"
                    >
                        <stop offset="0%" stopColor="#FFEEC3" />
                        <stop offset="45.17%" stopColor="#F1D76F" />
                        <stop offset="95%" stopColor="#FFF1C6" />
                    </linearGradient>
                    <linearGradient
                        id="fan-above-range-M"
                        x1="-54.02%"
                        x2="114.81%"
                        y1="-68.05%"
                        y2="122.2%"
                    >
                        <stop offset="0%" stopColor="#FFEEC3" />
                        <stop offset="45.17%" stopColor="#F1D76F" />
                        <stop offset="95%" stopColor="#FFF1C6" />
                    </linearGradient>
                    <linearGradient
                        id="fan-above-range-N"
                        x1="-38.01%"
                        x2="103.18%"
                        y1="20.19%"
                        y2="75.91%"
                    >
                        <stop offset="0%" stopColor="#FFEEC3" />
                        <stop offset="45.17%" stopColor="#F1D76F" />
                        <stop offset="95%" stopColor="#FFF1C6" />
                    </linearGradient>
                    <linearGradient
                        id="fan-above-range-O"
                        x1="-36.14%"
                        x2="104.65%"
                        y1="11.49%"
                        y2="66.5%"
                    >
                        <stop offset="0%" stopColor="#FFEEC3" />
                        <stop offset="45.17%" stopColor="#F1D76F" />
                        <stop offset="95%" stopColor="#FFF1C6" />
                    </linearGradient>
                    <filter
                        id="fan-above-range-a"
                        width="112.5%"
                        height="125.2%"
                        x="-6.2%"
                        y="-12.6%"
                        filterUnits="objectBoundingBox"
                    >
                        <feOffset in="SourceAlpha" result="shadowOffsetOuter1" />
                        <feGaussianBlur
                            in="shadowOffsetOuter1"
                            result="shadowBlurOuter1"
                            stdDeviation="4"
                        />
                        <feColorMatrix
                            in="shadowBlurOuter1"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0"
                        />
                    </filter>
                    <filter
                        id="fan-above-range-c"
                        width="127.6%"
                        height="127.5%"
                        x="-13.8%"
                        y="-13.8%"
                        filterUnits="objectBoundingBox"
                    >
                        <feOffset in="SourceAlpha" result="shadowOffsetOuter1" />
                        <feGaussianBlur
                            in="shadowOffsetOuter1"
                            result="shadowBlurOuter1"
                            stdDeviation="4"
                        />
                        <feColorMatrix
                            in="shadowBlurOuter1"
                            result="shadowMatrixOuter1"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0"
                        />
                        <feMerge>
                            <feMergeNode in="shadowMatrixOuter1" />
                            <feMergeNode in="SourceGraphic" />
                        </feMerge>
                    </filter>
                    <filter
                        id="fan-above-range-f"
                        width="112.5%"
                        height="125.2%"
                        x="-6.2%"
                        y="-12.6%"
                        filterUnits="objectBoundingBox"
                    >
                        <feOffset in="SourceAlpha" result="shadowOffsetOuter1" />
                        <feGaussianBlur
                            in="shadowOffsetOuter1"
                            result="shadowBlurOuter1"
                            stdDeviation="4"
                        />
                        <feColorMatrix
                            in="shadowBlurOuter1"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
                        />
                    </filter>
                    <path
                        id="fan-above-range-b"
                        d="M146.39 32.3c28.77 16.16 48.13 48.02 48.13 82.59H1.96c.03-32.25 17.3-65.3 48.15-82.58l-.01-.03a97.95 97.95 0 0196.29.02z"
                    />
                    <path
                        id="fan-above-range-d"
                        d="M115.49 15.24L58.05 115.3.38 15.24c33.95-19.6 78.74-21.04 115.11 0z"
                    />
                    <path
                        id="fan-above-range-g"
                        d="M106.19 31.93v.02c28.77 16.15 48.13 48.01 48.13 82.58H-38.24c.03-32.25 17.3-65.3 48.15-82.58l-.01-.03a97.95 97.95 0 0196.29.01z"
                    />
                    <radialGradient
                        id="fan-above-range-h"
                        cx="17.63%"
                        cy="17.91%"
                        r="243.91%"
                        fx="17.63%"
                        fy="17.91%"
                        gradientTransform="matrix(1 0 0 .46564 0 .1)"
                    >
                        <stop offset="0%" stopColor="#346AB2" />
                        <stop offset="51%" stopColor="#346AB2" />
                        <stop offset="83%" stopColor="#213E76" />
                    </radialGradient>
                    <radialGradient
                        id="fan-above-range-l"
                        cx="2.4%"
                        cy="-11.54%"
                        r="95.75%"
                        fx="2.4%"
                        fy="-11.54%"
                        gradientTransform="scale(.9997 1)"
                    >
                        <stop offset="14%" stopColor="#4782C3" />
                        <stop offset="34%" stopColor="#427CBF" />
                        <stop offset="61%" stopColor="#346AB2" />
                        <stop offset="69%" stopColor="#3164A8" />
                        <stop offset="82%" stopColor="#28528D" />
                        <stop offset="98%" stopColor="#1A3761" />
                        <stop offset="100%" stopColor="#18335B" />
                    </radialGradient>
                </defs>
                <g fill="none" fillRule="evenodd">
                    <g transform="translate(7 96)">
                        <use
                            fill="#000"
                            filter="url(#fan-above-range-a)"
                            xlinkHref="#fan-above-range-b"
                        />
                        <path
                            fill="#619B5C"
                            d="M50.1 32.11a95.98 95.98 0 0196.12 0l-47.97 83.76L50.1 32.1z"
                        />
                        <path
                            fill="#CB3C39"
                            d="M146.22 32.11c28.77 16.5 48.13 47.36 48.13 82.69H98.07l48.15-82.69z"
                        />
                        <path
                            fill="#E7EDE9"
                            d="M1.96 114.8a95.3 95.3 0 0148.15-82.69l48.13 82.69H1.96z"
                        />
                        <g filter="url(#fan-above-range-c)" transform="translate(40.2 .36)">
                            <mask id="fan-above-range-e" fill="#fff">
                                <use xlinkHref="#fan-above-range-d" />
                            </mask>
                            <use fill="#619B5C" xlinkHref="#fan-above-range-d" />
                            <g fill="#000" mask="url(#fan-above-range-e)">
                                <use
                                    filter="url(#fan-above-range-f)"
                                    xlinkHref="#fan-above-range-g"
                                />
                            </g>
                            <path
                                fill="#619B5C"
                                d="M9.9 31.75a95.98 95.98 0 0196.12 0l-47.97 83.76L9.9 31.75z"
                                mask="url(#fan-above-range-e)"
                            />
                        </g>
                        <g fillRule="nonzero">
                            <path
                                fill="url(#fan-above-range-h)"
                                d="M20.7.24V96.7l22.62-8.49 22.54 9.02V.24z"
                                transform="translate(56.11 64.8)"
                            />
                            <path
                                fill="#13335B"
                                d="M125.28 163c.55 0 1.01-.19 1.4-.57.4-.39.6-.86.6-1.43 0-.56-.2-1.03-.58-1.42-.4-.4-.87-.59-1.42-.59-.53 0-.99.18-1.38.55-.42.38-.62.87-.62 1.46 0 .56.19 1.03.57 1.42.4.39.87.58 1.43.58zm0-.33c-.46 0-.85-.17-1.17-.5a1.61 1.61 0 01-.49-1.17c0-.45.16-.84.48-1.17.33-.33.72-.5 1.18-.5.45 0 .84.17 1.17.5.32.33.48.72.48 1.17 0 .45-.16.85-.48 1.18-.33.32-.72.49-1.17.49zm-.3-.56v-.79h.13l.12.01c.1 0 .16.02.2.04.08.03.14.08.17.16a1 1 0 01.03.27c0 .14.02.24.04.31h.55l-.02-.06a.53.53 0 01-.02-.13v-.2c0-.23-.06-.4-.2-.5a.76.76 0 00-.3-.13.73.73 0 00.38-.15c.1-.08.15-.21.15-.4 0-.25-.1-.42-.3-.53-.11-.06-.26-.1-.43-.12a19.13 19.13 0 00-.92 0h-.16v2.22h.58zm.23-1.18h-.23v-.65h.14c.15 0 .26.02.34.05.12.04.18.13.18.25s-.04.2-.11.26a.54.54 0 01-.32.09z"
                            />
                            <path
                                fill="url(#fan-above-range-i)"
                                d="M61.04.24v95.03l2.18.87V.24z"
                                transform="translate(56.11 64.8)"
                            />
                            <path
                                fill="url(#fan-above-range-j)"
                                d="M23.34.24V95.56l2.15-.74V.24z"
                                transform="translate(56.11 64.8)"
                            />
                            <path
                                fill="url(#fan-above-range-k)"
                                d="M73.28 75.58l-6.56-1.42.14 6.73-6.13-2.7-1.22 6.61L54 80.96l-2.47 6.23-4.64-4.85-3.64 5.69-3.58-5.69-4.71 4.85-2.43-6.23-5.48 3.84-1.21-6.62-6.14 2.7.1-6.72-6.55 1.42 1.45-6.55-6.72.14 2.7-6.2-6.62-1.15L7.9 56.3l-6.25-2.46 4.79-4.6-5.62-3.68 5.69-3.57-4.86-4.72 6.25-2.43-3.85-5.5 6.62-1.19-2.7-6.13 6.72.1-1.42-6.55 6.6 1.45-.18-6.72 6.14 2.7 1.21-6.62 5.51 3.88 2.47-6.3 4.64 4.81 3.65-5.62 3.57 5.62 4.71-4.82 2.43 6.31 5.48-3.88L60.73 13l6.13-2.7-.1 6.72 6.55-1.42-1.45 6.52 6.73-.1-2.7 6.13 6.61 1.22-3.84 5.5 6.24 2.47-4.86 4.65 5.69 3.64-5.69 3.6 4.86 4.61-6.25 2.46 3.85 5.52-6.62 1.21 2.7 6.14-6.72-.14z"
                                transform="translate(56.11 64.8)"
                            />
                            <path
                                fill="url(#fan-above-range-l)"
                                d="M43.25 10.37A35.26 35.26 0 008 45.7a35.3 35.3 0 0035.34 35.22 35.24 35.24 0 0035.24-35.26 35.3 35.3 0 00-35.34-35.3z"
                                transform="translate(56.11 64.8)"
                            />
                            <path
                                fill="url(#fan-above-range-m)"
                                d="M23.55 59.11c.1-.59 0-1.21-.38-1.66a2.03 2.03 0 00-1.43-.94c-.8-.17-1.42.31-2.25.9-.83.6-1.46 1-1.63 1.84-.1.6 0 1.21.38 1.67.31.52.83.83 1.42.93.84.17 1.43-.31 2.26-.9.86-.59 1.49-1 1.63-1.84zm-3.75 1.67c-.28-.07-.52-.18-.7-.42-.16-.2-.2-.52-.16-.8.06-.38.27-.52 1.2-1.21.95-.7 1.22-.8 1.54-.73.27 0 .52.18.69.42.17.2.2.52.17.8-.07.3-.28.52-1.21 1.2-.94.7-1.22.8-1.53.74z"
                                transform="translate(56.11 64.8)"
                            />
                            <path
                                fill="url(#fan-above-range-n)"
                                d="M25.28 64.17l-1.56-1.66 1.04-1.04 1.8 1.87.73-.73-2.6-2.77L20.43 64l.8.83 1.7-1.66 1.55 1.66z"
                                transform="translate(56.11 64.8)"
                            />
                            <path
                                fill="url(#fan-above-range-o)"
                                d="M27.4 65.94l.83-1.21 2.22 1.63.62-.83-3.08-2.3-3.5 4.86.9.66 1.38-1.97 1.84 1.35.63-.83z"
                                transform="translate(56.11 64.8)"
                            />
                            <path
                                fill="url(#fan-above-range-p)"
                                d="M31.7 65.84l-2.7 5.3.96.52 2.7-5.3z"
                                transform="translate(56.11 64.8)"
                            />
                            <path
                                fill="url(#fan-above-range-q)"
                                d="M33.5 72.04a.98.98 0 01-.59-.52c-.1-.3-.07-.58.31-1.66.39-1.1.52-1.35.84-1.53a.82.82 0 01.8-.06 1 1 0 01.62 1.14l1.1.42a2.08 2.08 0 00-1.34-2.5 1.77 1.77 0 00-1.67.07c-.8.41-1.04 1.1-1.35 2.08-.31 1-.6 1.66-.28 2.46.28.52.7.94 1.25 1.14 1.04.39 2.18-.1 2.57-1.1l-1.05-.42c-.2.48-.72.62-1.2.48z"
                                transform="translate(56.11 64.8)"
                            />
                            <path
                                fill="url(#fan-above-range-r)"
                                d="M37.66 68.2l-1.18 5.86 1.08.27 1.21-5.9z"
                                transform="translate(56.11 64.8)"
                            />
                            <path
                                fill="url(#fan-above-range-s)"
                                d="M40.85 68.72l-2.56 5.82 1.14.1.42-1.04 2.04.18.28 1.1 1.22.08-1.63-6.14-.9-.1zm-.62 3.95l.9-2.15.52 2.25-1.42-.1z"
                                transform="translate(56.11 64.8)"
                            />
                            <path
                                fill="url(#fan-above-range-t)"
                                d="M45.02 73.74l-.25-4.92-1.1.04.37 6 3.65-.22-.04-1.03z"
                                transform="translate(56.11 64.8)"
                            />
                            <path
                                fill="url(#fan-above-range-u)"
                                d="M53.17 69.55l-2.05.73.31.93 1-.38.08.2a.9.9 0 01.07.84c-.1.28-.39.49-.63.6-.28.1-.52.1-.8-.08-.3-.17-.48-.41-.83-1.52-.38-1.11-.41-1.36-.31-1.67a1 1 0 01.59-.59.94.94 0 011.25.49l1.04-.42c-.21-.41-.6-.8-1.04-1-1.11-.49-2.4 0-2.88 1.1-.38.8-.1 1.46.28 2.47.38 1 .62 1.73 1.35 2.08a2 2 0 001.66.1c.6-.2 1.04-.62 1.32-1.21.2-.63.17-1.32-.07-1.87l-.34-.8z"
                                transform="translate(56.11 64.8)"
                            />
                            <path
                                fill="url(#fan-above-range-v)"
                                d="M56.5 64.8l-1.01.59 1.87 3.43c0 .07.07.07.07.1a.97.97 0 01-.42 1.36c-.06.07-.1.1-.17.1a1 1 0 01-1.25-.59l-1.87-3.4-1 .6 1.87 3.43c.07.06.07.1.1.17a2.02 2.02 0 002.78.62s.06 0 .1-.1c1-.6 1.35-1.87.8-2.88l-1.88-3.43z"
                                transform="translate(56.11 64.8)"
                            />
                            <path
                                fill="url(#fan-above-range-w)"
                                d="M57.12 64.38l3.71 4.68.87-.76-3.68-4.65z"
                                transform="translate(56.11 64.8)"
                            />
                            <path
                                fill="url(#fan-above-range-x)"
                                d="M61.66 61.05a1.9 1.9 0 00-1.45.7l-1.46 1.45 4.13 4.27L64.33 66c.42-.41.7-.93.7-1.52 0-.94-.63-1.46-1.25-2.15-.66-.66-1.18-1.29-2.12-1.29zm1.87 4.27l-.58.62-2.71-2.8.59-.63c.2-.2.52-.38.83-.31.31.07.7.31 1.32.93.62.63.9.94.94 1.32-.04.35-.14.66-.39.87z"
                                transform="translate(56.11 64.8)"
                            />
                            <path
                                fill="url(#fan-above-range-y)"
                                d="M66.27 61.71l-1.17-.83 1.24-1.9-.83-.6-1.25 1.95-1.14-.8 1.46-2.22-.84-.59-2.08 3.23 4.9 3.32 2.04-3.22-.83-.56z"
                                transform="translate(56.11 64.8)"
                            />
                            <path
                                fill="url(#fan-above-range-z)"
                                d="M71.75 44.52l3.13-4.48h-2.22l-3.3 4.86v-4.86h-1.8v11.17h1.8v-3.4l1.22-1.73 2.39 5.13 2.11.03z"
                                transform="translate(56.11 64.8)"
                            />
                            <path
                                fill="url(#fan-above-range-A)"
                                d="M60.83 50.62c1.42 1.1 3.43.9 4.54-.52.94-1.15.94-2.5.94-4.44 0-1.94 0-3.3-.94-4.44-.17-.2-.3-.38-.52-.52a3.21 3.21 0 00-4.54.52c-.94 1.11-.94 2.57-.94 4.44 0 1.87 0 3.3.94 4.44.14.2.31.38.52.52zm.83-8.11c.31-.39.73-.6 1.22-.6.41-.06.9.21 1.14.6.38.48.49 1 .49 3.12 0 2.15-.1 2.67-.49 3.12-.28.38-.7.59-1.14.59-.49 0-.94-.21-1.22-.6-.38-.48-.48-1-.48-3.11 0-2.15.1-2.67.48-3.12z"
                                transform="translate(56.11 64.8)"
                            />
                            <path
                                fill="url(#fan-above-range-B)"
                                d="M57.08 40.74a3.21 3.21 0 00-4.54.52c-1 1.1-.94 2.56-.94 4.44 0 1.87 0 3.29.94 4.43a3.21 3.21 0 005.06 0c.94-1.14.94-2.5.94-4.43 0-1.95 0-3.3-.94-4.44-.17-.21-.3-.38-.52-.52zm-.86 8c-.28.39-.7.6-1.15.6-.45 0-.93-.21-1.21-.6-.38-.48-.49-1-.49-3.11 0-2.15.1-2.67.49-3.12.31-.39.73-.6 1.21-.6.42 0 .9.21 1.15.6.38.48.48 1 .48 3.12 0 2.15-.1 2.67-.48 3.12z"
                                transform="translate(56.11 64.8)"
                            />
                            <path
                                fill="url(#fan-above-range-C)"
                                d="M50.56 43.16c0-1.87-1.04-3.12-2.87-3.12h-3.75v11.17h3.92c1.66 0 2.88-1.11 2.88-3.23 0-1.45-.73-2.18-1.32-2.5a2.78 2.78 0 001.14-2.32zM45.74 42h1.77c.73 0 1.32.52 1.32 1.24 0 .73-.59 1.32-1.32 1.32h-1.77V42zm1.95 7.28h-1.95v-2.78h1.95c.62.1 1.1.6 1.2 1.22.11.8-.4 1.45-1.2 1.56z"
                                transform="translate(56.11 64.8)"
                            />
                            <path
                                fill="url(#fan-above-range-D)"
                                d="M40.4 41.99v-1.95h-6.17v11.17l6.17-.07v-1.9h-4.33v-2.75h3.7v-1.9h-3.7v-2.6z"
                                transform="translate(56.11 64.8)"
                            />
                            <path
                                fill="url(#fan-above-range-E)"
                                d="M26.01 47.4c0 2.35 1.53 3.91 3.43 3.91 1.95 0 3.44-1.56 3.44-3.92v-7.35h-1.84v7.28c0 1.25-.63 2.05-1.63 2.05-1 0-1.63-.73-1.63-2.05v-7.2h-1.84v7.27h.07z"
                                transform="translate(56.11 64.8)"
                            />
                            <path
                                fill="url(#fan-above-range-F)"
                                d="M19.42 40.04v11.17h6.07v-1.94h-4.23v-9.23z"
                                transform="translate(56.11 64.8)"
                            />
                            <path
                                fill="url(#fan-above-range-G)"
                                d="M17 45.45a2.6 2.6 0 001.14-2.29c0-1.87-1.11-3.12-2.92-3.12h-3.74v11.17h3.88c1.67 0 2.88-1.11 2.92-3.23 0-1.49-.73-2.22-1.29-2.53zM13.27 42h1.77c.73 0 1.32.52 1.32 1.24 0 .73-.6 1.32-1.32 1.32h-1.77V42zm1.88 7.28h-1.88v-2.78h1.88c.62.1 1.14.6 1.2 1.22.11.8-.4 1.45-1.2 1.56z"
                                transform="translate(56.11 64.8)"
                            />
                            <path
                                fill="url(#fan-above-range-H)"
                                d="M60.03 32.7l1.15 1.62 3.4-2.39 6.65-.9-1.25-1.77-4.43.83 2.25-3.91-1.25-1.77-3.12 5.9z"
                                transform="translate(56.11 64.8)"
                            />
                            <path
                                fill="url(#fan-above-range-I)"
                                d="M60.1 29.57l-3.78-2.87 1.53-1.98 3.12 2.46L62 25.76l-3.16-2.4 1.46-1.86 3.78 2.8 1.04-1.38-5.3-4.03-6.14 8.01 5.3 4.1z"
                                transform="translate(56.11 64.8)"
                            />
                            <path
                                fill="url(#fan-above-range-J)"
                                d="M53.37 24.58l-4.44-1.25 2.26-8.04-1.87-.52-2.74 9.74 6.3 1.77z"
                                transform="translate(56.11 64.8)"
                            />
                            <path
                                fill="url(#fan-above-range-K)"
                                d="M45.5 24.2l-.17-1.77-4.58.42-.73-8.32-1.98.13.9 10.06z"
                                transform="translate(56.11 64.8)"
                            />
                            <path
                                fill="url(#fan-above-range-L)"
                                d="M37.56 25.03l-.73-1.6-4.27 1.91-1.04-2.21 3.65-1.67-.73-1.63-3.64 1.67-.98-2.12 4.27-2.01-.73-1.6-6.07 2.74 4.23 9.2z"
                                transform="translate(56.11 64.8)"
                            />
                            <path
                                fill="url(#fan-above-range-M)"
                                d="M26.63 32.87l-2.29-2.05-.3-2 5.16 1.07 1.56-1.74-7-1.35-.77-5.13-1.63 1.77.9 5.61-3.29-2.9-1.32 1.45 7.67 6.72z"
                                transform="translate(56.11 64.8)"
                            />
                            <path
                                fill="url(#fan-above-range-N)"
                                d="M59.72 38.87a17.9 17.9 0 00-33.16-.07h1.05a17.03 17.03 0 0115.53-10.16 16.9 16.9 0 0115.54 10.23h1.04z"
                                transform="translate(56.11 64.8)"
                            />
                            <path
                                fill="url(#fan-above-range-O)"
                                d="M50.04 62.13a18.11 18.11 0 009.71-9.7h-1.04a17 17 0 01-31 0h-1.04a17.86 17.86 0 0023.37 9.7z"
                                transform="translate(56.11 64.8)"
                            />
                        </g>
                    </g>
                    {position === "right" && (
                        <React.Fragment>
                            <path
                                stroke="#99A4B2"
                                strokeWidth=".5"
                                d="M103.5 0v93.5M280.59 79v82h-100.5"
                            />
                            <g transform="translate(179 155.5)">
                                <path
                                    fill="#444453"
                                    d="M5.5 0a5.5 5.5 0 100 11 5.5 5.5 0 000-11zm0 1a4.5 4.5 0 110 9 4.5 4.5 0 010-9z"
                                />
                                <path
                                    fill="#FFF"
                                    fillRule="nonzero"
                                    d="M5.5 1a4.5 4.5 0 110 9 4.5 4.5 0 010-9z"
                                />
                                <circle cx="5.5" cy="5.5" r="2.5" fill="#CB3C39" />
                            </g>
                        </React.Fragment>
                    )}
                    {position === "left" && (
                        <React.Fragment>
                            <path
                                xmlns="http://www.w3.org/2000/svg"
                                stroke="#99A4B2"
                                strokeWidth=".5"
                                d="M103.5 0v92.5M-80.41 78 v82 H19"
                            />

                            <g
                                xmlns="http://www.w3.org/2000/svg"
                                transform="translate(19 155)"
                            >
                                <path
                                    fill="#444453"
                                    d="M5.5 0a5.5 5.5 0 100 11 5.5 5.5 0 000-11zm0 1a4.5 4.5 0 110 9 4.5 4.5 0 010-9z"
                                />
                                <path
                                    fill="#FFF"
                                    fillRule="nonzero"
                                    d="M5.5 1a4.5 4.5 0 110 9 4.5 4.5 0 010-9z"
                                />
                                <circle cx="5.5" cy="5.5" r="2.5" fill="#3B73B9" />
                            </g>
                        </React.Fragment>
                    )}
                    {position === "center" && (
                        <path
                            xmlns="http://www.w3.org/2000/svg"
                            stroke="#99A4B2"
                            strokeWidth=".5"
                            d="M103.5 0v93.5"
                        />
                    )}
                    {position === "leftGreen" && (
                        <React.Fragment>
                            <path
                                xmlns="http://www.w3.org/2000/svg"
                                stroke="#99A4B2"
                                strokeWidth=".5"
                                d="M103.5 0 v92.5 M-45.41 108 v0 H49"
                            />
                            <g transform="translate(50 102)">
                                <path
                                    fill="#444453"
                                    d="M5.5 0a5.5 5.5 0 100 11 5.5 5.5 0 000-11zm0 1a4.5 4.5 0 110 9 4.5 4.5 0 010-9z"
                                />
                                <path
                                    fill="#FFF"
                                    fillRule="nonzero"
                                    d="M5.5 1a4.5 4.5 0 110 9 4.5 4.5 0 010-9z"
                                />
                                <circle cx="5.5" cy="5.5" r="2.5" fill="#619B5C" />
                            </g>

                        </React.Fragment>
                    )}

                    {position === "rightGreen" && (
                        <React.Fragment>
                            <path
                                stroke="#99A4B2"
                                strokeWidth=".5"
                                d="M103.5 0v93.5M233.59 108 v0 h-70"
                            />
                            <g transform="translate(150 102)">
                                <path
                                    fill="#444453"
                                    d="M5.5 0a5.5 5.5 0 100 11 5.5 5.5 0 000-11zm0 1a4.5 4.5 0 110 9 4.5 4.5 0 010-9z"
                                />
                                <path
                                    fill="#FFF"
                                    fillRule="nonzero"
                                    d="M5.5 1a4.5 4.5 0 110 9 4.5 4.5 0 010-9z"
                                />
                                <circle cx="5.5" cy="5.5" r="2.5" fill="#619B5C" />
                            </g>
                        </React.Fragment>
                    )}
                    <g transform="translate(98 92)">
                        <path
                            fill="#444453"
                            d="M5.5 0a5.5 5.5 0 100 11 5.5 5.5 0 000-11zm0 1a4.5 4.5 0 110 9 4.5 4.5 0 010-9z"
                        />
                        <path
                            fill="#FFF"
                            fillRule="nonzero"
                            d="M5.5 1a4.5 4.5 0 110 9 4.5 4.5 0 010-9z"
                        />
                        <circle cx="5.5" cy="5.5" r="2.5" fill="#619B5C" />
                    </g>
                </g>
            </svg>
        </div>
    );
};

Kbbimage.propTypes = {
    position: PropTypes.string
};

export default Kbbimage;
